import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'

import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'
import { useApi } from '@fortem-monorepo/react-spa'
import { SearchSelect, SearchSelectProps } from '@fortem-monorepo/react-ui'

export interface CurrencyIdInputProps extends Omit<SearchSelectProps, 'options'> {}

export const CurrencyIdInput: React.FC<CurrencyIdInputProps> = ({ ...props }) => {
  const api = useApi()

  const query = useQuery({
    queryKey: ['static/currencies'],
    queryFn: () => api.misc.getCurrencies(),
  })

  const options = useMemo(() => {
    return sortAlphabeticallyByKey(query.data ?? [], 'label').map((o) => ({
      ...o,
      value: o.value.toString(),
    }))
  }, [query.data])

  return <SearchSelect options={options} loading={query.isFetching || props.loading} {...props} />
}
